export const closePermanentMapEventName = "smartguide:close-permanent-map";
